import { useRegisterSW } from 'virtual:pwa-register/react';
import { Text } from './Text';
import { colors } from '@/theme/tokens';
import { usePos } from '@/store/pos';
import styles from './UpdateToast.module.css';

/**
 * Offers a new build instead of installing it.
 *
 * The service worker is registered with `registerType: 'prompt'` precisely so
 * this decision is ours. Applying an update calls `skipWaiting()` and reloads
 * the page; firing that while a twenty-line cement sale is half-entered throws
 * the cart away. So the toast is suppressed entirely whenever there is
 * something in the cart — the shopkeeper finishes the sale, and the offer
 * appears afterwards.
 */
export function UpdateToast() {
  const cartBusy = usePos((s) => s.cart.length > 0);
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW();

  if (!needRefresh || cartBusy) return null;

  return (
    <div className={styles.toast} role="status">
      <Text weight={700} size={12.5} color={colors.surfaceAlt} className="grow">
        ມີເວີຊັນໃໝ່
      </Text>
      <button
        type="button"
        onClick={() => void updateServiceWorker(true)}
        className={styles.action}
      >
        <Text weight={800} size={12.5} color={colors.navy}>
          ອັບເດດ
        </Text>
      </button>
      <button type="button" onClick={() => setNeedRefresh(false)} className={styles.later}>
        <Text size={12} color={colors.onDarkSubtle}>
          ພາຍຫຼັງ
        </Text>
      </button>
    </div>
  );
}
